import { Stack } from '@fluentui/react';
import { TextField } from '@h2oai/ui-kit';
import { memo, useCallback, useEffect, useRef, useState } from 'react';

import { useDebouncedCallback } from '../../../../utils/hooks';
import { StringFilterProps } from './types';

export const StringFilter = memo((props: StringFilterProps) => {
  const { onChange, value, inputLabel } = props;
  const [localValue, setLocalValue] = useState(value ?? '');
  const hasInitialized = useRef(false);

  const debouncedOnChange = useDebouncedCallback((inputData: string) => {
    const readableValue = inputData ? `${inputLabel || 'Filter'}: ${inputData}` : '';
    onChange(inputData, readableValue);
  }, 400);

  useEffect(() => {
    setLocalValue(value ?? '');
  }, [value]);

  useEffect(() => {
    if (value && !hasInitialized.current) {
      const readableValue = `${inputLabel || 'Filter'}: ${value}`;
      onChange(value, readableValue);
      hasInitialized.current = true;
    }
  }, [value, inputLabel, onChange]);

  const handleInputChange = useCallback(
    (_e: any, inputData?: string) => {
      const newValue = inputData ?? '';
      setLocalValue(newValue);
      debouncedOnChange(newValue);
    },
    [debouncedOnChange]
  );

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end">
      <TextField onChange={handleInputChange} value={localValue} label={inputLabel} />
    </Stack>
  );
});
